module.exports = __webpack_public_path__ + "img/m2-en.d493be75.jpeg";